import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

import Company from './Company';
import Office from './Office';

export default class JobOffer extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get slug() {
    return get(this, '_slug.value', '');
  }

  get name() {
    return this.system.name;
  }

  get position() {
    return get(this, '_stanowisko.value', '');
  }

  get company() {
    return get(this, '_spolka.value[0]', new Company());
  }

  get location() {
    return get(this, '_lokalizacja.value', []);
  }

  get country() {
    return get(this, '_kraj.value[0].name', '');
  }

  get photo() {
    return get(this, '_zdjecie.value[0]', {});
  }

  get description() {
    return get(this, '_opis.value', '');
  }

  get office() {
    return get(this, '_biuro.value[0]', new Office());
  }

  get seo() {
    const seoModel = get(this, '_seo.value[0].model', {});

    if (!seoModel.title) {
      seoModel.title = this.name;
    }

    return seoModel;
  }

  get tags() {
    return get(this, '_tagi.value', []).map(item => ({
      codename: get(item, 'system.codename', ''),
      name: get(item, 'tag.value', '')
    }));
  }

  get traffitFormLink() {
    return get(this, '_traffit___link_do_formularza.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/JobOffer.js